import { Loader2 } from 'lucide-react';
import type { ReactNode } from 'react';

import { ADMIN_ACTION_BUTTON, BUTTON_PRIMARY } from '@/shared/ui-class';
import { cn } from '@/shared/cn';

export type AdminSaveBarProps = {
  dirty: boolean;
  saving?: boolean;
  onSave: () => void;
  onDiscard?: () => void;
  note?: ReactNode;
  saveLabel?: string;
  className?: string;
};

export function AdminSaveBar({
  dirty,
  saving = false,
  onSave,
  onDiscard,
  note,
  saveLabel = 'Save',
  className,
}: AdminSaveBarProps) {
  if (!dirty) return null;

  return (
    <div
      className={cn(
        'sticky bottom-0 z-10 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-divider bg-white px-4 py-3 dark:bg-zinc-950',
        className,
      )}
    >
      {note ? (
        <div className="min-w-0 flex-1 text-sm text-muted">{note}</div>
      ) : null}
      <div className="ml-auto flex flex-wrap items-center gap-2">
        {onDiscard ? (
          <button
            type="button"
            disabled={saving}
            onClick={onDiscard}
            className={ADMIN_ACTION_BUTTON}
          >
            Discard
          </button>
        ) : null}
        <button
          type="button"
          disabled={saving}
          onClick={onSave}
          className={BUTTON_PRIMARY}
        >
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
          {saveLabel}
        </button>
      </div>
    </div>
  );
}
